import { i18nTranslate } from 'src/utils'

export const settingsData = [
  // {
  //   key: i18nTranslate(
  //     'settings.emailNotifyText',
  //     'Send me weekly emails with new sales and special offers'
  //   ),
  //   label: 'Send me weekly emails with new sales and special offers',
  //   buttonType: 'Toggle',
  // },
  // {
  //   key: i18nTranslate(
  //     'settings.notifySms',
  //     'Send all sale notifications via SMS'
  //   ),

  //   label: 'Send all sale notifications via SMS',
  //   buttonType: 'Toggle',
  // },
  // {
  //   key: i18nTranslate(
  //     'settings.consentData',
  //     'Consent for personal data collection and processing'
  //   ),
  //   label: 'Consent for personal data collection and processing',
  //   buttonType: 'Toggle',
  // },
  {
    key: i18nTranslate(
      'settings.exportData',
      'Export my personal data information'
    ),
    label: 'Export my personal data information',
    buttonType: 'Button',
    buttonValue: i18nTranslate('settings.exportText', 'Export'),
  },
  {
    key: i18nTranslate('settings.freezeAccount', 'Freeze Account'),
    label: 'Freeze my account',
    type: 'FREEZE',
    buttonType: 'Toggle',
  },
  {
    key: i18nTranslate('settings.deleteAccount', 'Delete Account'),
    label: 'Delete my account',
    type: 'DELETE',
    buttonType: 'Toggle',
  },
]
